<ng-container #productCarousel />
